// ======================================================================
// File Name       : ContentQuestionEditDescriptionType
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, FormControl, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import SelectBox from '../../components/SelectBox';
import FormControlValidate from '../FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import { ANSWER_FORMULA } from '../../constants/ContentConstant';

class ContentQuestionEditDescriptionType extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onCheckBox = this.onCheckBox.bind(this);
    this.validation = this.validation.bind(this);
  }
  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.props.onInputChange(name, value);
    } else {
      this.props.onInputChange(event, data);
    }
  }
  onCheckBox(event) {
    this.props.onCheckBoxChange(event);
  }
  validation() {
    let isValid = true;
    for (const key in this.refsToValidate) {
      const ref = this.refsToValidate[key];
      if (ref.validation && !ref.validation()) {
        isValid = false;
      }
    }
    return isValid;
  }
  render() {
    const {
      answerFormula,
      optionMarkKind,
      onInputChange,
      onShowDialogBtnClick,
      inputLimitType,
      inputLimit,
      answerInfo,
      questionUseForm,
    } = this.props;
    this.refsToValidate = [];
    let disableButton = null;
    const disableInputLimitType = answerFormula == ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER;
    if ((answerFormula == ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT ||
      answerFormula == ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER ||
      answerFormula == ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER) &&
      answerInfo.length != 0 && answerInfo.length >= 20) {
      disableButton = true;
    } else if ((answerFormula == ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER ||
      answerFormula == ANSWER_FORMULA.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER) &&
      answerInfo.length >= 1) {
      disableButton = true;
    } else {
      disableButton = false;
    }
    const correctAnswerNumberList = [];
    const isQuestionUseForm = questionUseForm == '1';
    if (answerInfo && answerInfo.length > 0) {
      for (let i = 0; i < answerInfo.length; i++) {
        if (answerInfo[i].correctAnswerNumber) {
          correctAnswerNumberList.push(answerInfo[i].correctAnswerNumber);
        } else {
          correctAnswerNumberList.push('');
        }
      }
    }
    return (
      <Form className='form-horizontal'>
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} className="margin-top-10">
                解答方式
              </Col>
              <Col sm={7}>
                <SelectBox
                  data={SELECT_BOX_DATA.ANSWER_FORMULA}
                  name="answerFormula"
                  value={answerFormula}
                  onChange={this.onChange}
                  required
                  label="解答方式"
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} className="margin-top-10">
                記述文字数の制限をする
              </Col>
              <Col sm={7}>
                <Col sm={2} className="padding-left-clear padding-right-clear">
                  <Form.Check
                    type='checkbox'
                    className="margin-left-30"
                    checked={inputLimitType}
                    name="inputLimitType"
                    id="inputLimitType"
                    onChange={this.onCheckBox}
                    disabled={disableInputLimitType} />
                </Col>
                <Col sm={7} className="padding-left-clear">
                  <FormControlValidate
                    type="text"
                    name="inputLimit"
                    id="inputLimit"
                    value={inputLimit}
                    onChange={this.onChange}
                    disabled={!inputLimitType}
                    validateType={VALIDATE_TYPE.NUMERIC_WITHOUT_ZERO}
                    label="記述文字数の制限"
                    maxLength="7"
                    required={inputLimitType || false}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
                <Col sm={3} className="padding-left-clear margin-top-10">
                  文字まで
                </Col>
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} className="margin-top-10">
                正答情報
                {!isQuestionUseForm ?
                  <span className="required">&nbsp;(※)</span>
                  : null
                }
              </Col>
              <Col sm={3}>
                <Button
                  variant="primary"
                  className="btn-96"
                  onClick={onShowDialogBtnClick}
                  disabled={disableButton}
                >
                  追加
                </Button>
              </Col>
              {(answerFormula == ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER &&
                !isQuestionUseForm &&
                answerInfo && answerInfo.length) ?
                  <Col
                    as={Form.Label}
                    sm={{
                      span: 7,
                      offset: 4
                    }}>
                    <FormControlValidate
                      label={'正答情報'}
                      validateType={VALIDATE_TYPE.QUESTION_ANSWER}
                      value={correctAnswerNumberList || []}
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                    />
                  </Col> : null
              }
              {!isQuestionUseForm && <Col
                sm={{
                  span: 7,
                  offset: 4
                }}
                hidden={answerInfo.length > 0}>
                <FormControlValidate
                  label="正答情報"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={answerInfo.length ? answerInfo.length : ''}
                  required
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>}
            </Col>
          </Form.Group>
        </Col>
      </Form>
    );
  }
}

export default ContentQuestionEditDescriptionType;
